import React from 'react';

import Spinner from 'ui-library/Spinner';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

function AlignmentTab(): JSX.Element {
  return (
    <>
      <div className="loading-screen">
        <Spinner />
      </div>
      <div className="alignment-warning" />
      <div className="full-container hidden">
        <div className="fixed-top">
          <div className="alignment-container" />
        </div>
        <div className="alignments-container">
          <div className="sortable-wrapper" />
        </div>
        <div className="fixed-bottom">
          <div className="statsView-container" />
          <div className="summaryMapView-container" />
        </div>
      </div>
    </>
  );
}

export default makeDeprecatedJadeStyleTemplate(AlignmentTab);
